module.exports = __webpack_public_path__ + "img/price-offer.fd95affa.svg";